import { render, staticRenderFns } from "./wzbRight.vue?vue&type=template&id=03e8bb6a&scoped=true&"
import script from "./wzbRight.vue?vue&type=script&lang=js&"
export * from "./wzbRight.vue?vue&type=script&lang=js&"
import style0 from "./wzbRight.vue?vue&type=style&index=0&id=03e8bb6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8bb6a",
  null
  
)

export default component.exports